import { PageId } from 'constants/pages'

export const enum PageIdWoofzPppWoofy {
  DOG_AGE_WOOFZ_PPP_WOOFY = PageId.DOG_AGE_WOOFZ_PPP_WOOFY,
  DOG_OWNER_WOOFZ_PPP_WOOFY = PageId.DOG_OWNER_WOOFZ_PPP_WOOFY,
  TRAINING_COMMANDS_WOOFZ_PPP_WOOFY = PageId.TRAINING_COMMANDS_WOOFZ_PPP_WOOFY,
  URGE_WOOFZ_PPP_WOOFY = PageId.URGE_WOOFZ_PPP_WOOFY,
  DOG_BREED_WOOFZ_PPP_WOOFY = PageId.DOG_BREED_WOOFZ_PPP_WOOFY,
  FACING_CHALLENGES_WOOFZ_PPP_WOOFY = PageId.FACING_CHALLENGES_WOOFZ_PPP_WOOFY,
  FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY = PageId.FACING_CHALLENGES_2_WOOFZ_PPP_WOOFY,
  BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY = PageId.BEHAVIOR_FREQUENCY_WOOFZ_PPP_WOOFY,
  URGE_PROGRAM_WOOFZ_PPP_WOOFY = PageId.URGE_PROGRAM_WOOFZ_PPP_WOOFY,
  BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY = PageId.BEHAVIOR_FEELINGS_WOOFZ_PPP_WOOFY,
  FIX_BEHAVIOR_WOOFZ_PPP_WOOFY = PageId.FIX_BEHAVIOR_WOOFZ_PPP_WOOFY,
  URGE_4_WOOFZ_PPP_WOOFY = PageId.URGE_4_WOOFZ_PPP_WOOFY,
  COMMANDS_WOOFZ_PPP_WOOFY = PageId.COMMANDS_WOOFZ_PPP_WOOFY,
  PARENT_GOAL_WOOFZ_PPP_WOOFY = PageId.PARENT_GOAL_WOOFZ_PPP_WOOFY,
  TRAINING_PLACE_WOOFZ_PPP_WOOFY = PageId.TRAINING_PLACE_WOOFZ_PPP_WOOFY,
  TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY = PageId.TRAINING_FREQUENCY_WOOFZ_PPP_WOOFY,
  URGE_5_WOOFZ_PPP_WOOFY = PageId.URGE_5_WOOFZ_PPP_WOOFY,
  PREPARE_FLOW_WOOFZ_PPP_WOOFY = PageId.PREPARE_FLOW_WOOFZ_PPP_WOOFY,
  EMAIL_WOOFZ_PPP_WOOFY = PageId.EMAIL_WOOFZ_PPP_WOOFY,
  NEWSLETTER_URGE_WOOFZ_PPP_WOOFY = PageId.NEWSLETTER_URGE_WOOFZ_PPP_WOOFY,
  LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY = PageId.LAST_CHANCE_OFFER_WOOFZ_PPP_WOOFY,
  SUBSCRIPTIONS_WOOFZ_PPP_WOOFY = PageId.SUBSCRIPTIONS_WOOFZ_PPP_WOOFY,
  CHAT_UPSELL_WOOFZ_PPP_WOOFY = PageId.CHAT_UPSELL_WOOFZ_PPP_WOOFY,
  CHAT_WOOFZ_PPP_WOOFY = PageId.CHAT_WOOFZ_PPP_WOOFY,
  ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY = PageId.ACCOUNT_WOOFY_WOOFZ_PPP_WOOFY,
  DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY = PageId.DOWNLOAD_WOOFY_WOOFZ_PPP_WOOFY,
  DOWNLOAD_WOOFZ_PPP_WOOFY = PageId.DOWNLOAD_WOOFZ_PPP_WOOFY,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
